import React from "react";
import PropTypes from "prop-types";

export default function LabelValue(props) {
  let { label, value } = props;
  return (
    <div className="km__c--labelvalue-container">
      <label>{label}</label>
      <div className="km__c--labelvalue-value">{value}</div>
    </div>
  );
}
LabelValue.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};
